<template>
  <div class="expected-end-of-month card-box">
    <div class="remaining-variables container-padding">
      <div class="updated-to">מעודכן ל-{{ updateTime }}</div>
      <div class="title">
        <template>כמה כסף נשאר להוציא על הוצאות משתנות ב{{this.monthName}}?</template>
      </div>
      <div class="top-of-mind-metric positive">
        ***
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  name: 'ExpectedEndOfMonth',
  computed: {
    ...mapGetters('cashflowView', ['monthName', 'budgetUpdatedAt']),
    updateTime() {
      const updateHour = moment(this.budgetUpdatedAt).format('H:mm');
      const updateDate = moment(this.budgetUpdatedAt).format('D.M.YY');
      return `${updateHour}, ${updateDate}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  .expected-end-of-month {
    margin-bottom: 16px;

    .container-padding {
      padding: 8px 18px ;
    }

    .remaining-variables {
      padding-top: 18px;
    }

    .updated-to {
      color: $riseup_gray_2;
      font-size: 10px;
    }

    .title {
      font-family: GretaSans;
      font-size: 24px;
      font-weight: bold;
      line-height: 1.00em;
      margin: 4px 0 32px;
    }

    .top-of-mind-metric {
      font-family: SimplerPro;
      font-size: 46px;
      line-height: 32px;
      margin: 0 0 18px;
      font-weight: bold;

      &.positive {
        color: $riseup_green;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/blocked-month/components/ExpectedEndOfMonth.vue